module.exports = __webpack_public_path__ + "OpenSans-Bold.470dc6a3ee4054e3ded6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Bold.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-Bold.ttf
// module chunks = styles